var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.667,
    height: 19.667,
    viewBox: "0 0 19.667 19.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    d: "M10.4.563A9.833,9.833,0,1,0,20.229,10.4,9.835,9.835,0,0,0,10.4.563Zm0,4.362A1.665,1.665,0,1,1,8.73,6.589,1.665,1.665,0,0,1,10.4,4.924ZM12.616,15a.476.476,0,0,1-.476.476H8.651A.476.476,0,0,1,8.175,15v-.952a.476.476,0,0,1,.476-.476h.476V11.03H8.651a.476.476,0,0,1-.476-.476V9.6a.476.476,0,0,1,.476-.476h2.538a.476.476,0,0,1,.476.476v3.965h.476a.476.476,0,0,1,.476.476Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#0069d0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.2e9bf001dd6c386bf88c98e336c3eee8.svg";
export { ForwardRef as ReactComponent };